import { render, staticRenderFns } from "./incl-pharmacy-footer-logos.vue?vue&type=template&id=703ca1fe&scoped=true"
import script from "./incl-pharmacy-footer-logos.vue?vue&type=script&lang=js"
export * from "./incl-pharmacy-footer-logos.vue?vue&type=script&lang=js"
import style0 from "./incl-pharmacy-footer-logos.vue?vue&type=style&index=0&id=703ca1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ca1fe",
  null
  
)

export default component.exports